<div class="flex flex-col h-full gap-2 p-4">
  <div
    class="flex flex-row flex-wrap items-center w-full gap-2"
    #matConfiguratorHeader
  >
    <sia-select-box
      [selectBoxOptions]="{
        fixedDataSource: perspectives,
        value: selectedPerspectiveId,
      }"
      [(value)]="selectedPerspectiveId"
      label="Prospettiva"
      class="!w-1/6 min-w-[200px]"
    ></sia-select-box>
  </div>

  <div
    [style]="
      'height: calc(100% - ' + matConfiguratorHeader.offsetHeight + 'px)'
    "
  >
    @if (gridConfiguration && dataBaseFields) {
      <mat-tab-group dynamicHeight style="height: 100%">
        <mat-tab label="Generali">
          <sia-mat-grid-configurator-general
            [(gridConfiguration)]="gridConfiguration"
            [databaseFields]="dataBaseFields"
            class="h-full overflow-auto"
          ></sia-mat-grid-configurator-general>
        </mat-tab>
        <mat-tab label="Colonne">
          <sia-mat-grid-configurator-columns
            [(gridConfiguration)]="gridConfiguration"
            [dataBaseFields]="dataBaseFields"
            class="h-full overflow-auto"
          >
          </sia-mat-grid-configurator-columns>
        </mat-tab>
        <mat-tab label="Template">
          <button mat-button (click)="importAction()" class="w-full mt-2">
            <mat-icon>file_upload</mat-icon>
            {{ 'Importa Template' | siaTranslate }}
          </button>
          <sia-template-configurator
            [template]="gridConfiguration.template!"
            (templateChange)="applyTemplateConfiguration($event)"
            [hideViewSelector]="true"
          >
          </sia-template-configurator>
        </mat-tab>
      </mat-tab-group>
    }
  </div>
</div>
